"use client";

import { motion } from "framer-motion";

import ExpeditionGearDiagram from "./ExpeditionGearInstructions";

import gearImgBackground from "../../assets/images/expedition-gear/backgroundImage.png";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};


export default function EssentialGears() {
  return (
    <main className="bg-gray-200 text-white overflow-x-hidden">
      {/* ================= GEAR DIAGRAM ================= */}
      <section
        className="relative w-full px-6 md:px-10 py-16 bg-center overflow-x-hidden"
        style={{ backgroundImage: `url(${gearImgBackground})` }}
      >
        {/* LIGHT BACKGROUND OVERLAY */}
        <div className="absolute inset-0 bg-white/60 z-0" />

        {/* GRID — VERTICALLY CENTER BOTH SECTIONS */}
        <div
          className="
            relative z-10 max-w-[1600px] mx-auto
            grid grid-cols-1 lg:grid-cols-12
            gap-12 lg:gap-16 px-autp
            lg:px-16
            items-center
            gear-info-section
          "
        >
          {/* ================= INFO ================= */}
          <div className="lg:col-span-4 text-center lg:text-left">
        
            <div className="space-y-6">
              <motion.div
                variants={fadeUp}
                className="
                  inline-flex items-center gap-2
                  rounded-full
                  border border-neutral-300/60
                  bg-gray-600/30
                  px-3 py-1
                  text-xs uppercase tracking-[0.25em]
                  text-neutral-600
                  backdrop-blur
                "
              >
          
                Essential Gears
              </motion.div>

              <motion.h1
                variants={fadeUp}
                className="
                  text-3xl font-semibold tracking-tight
                  text-[#192c37]
                  sm:text-4xl md:text-[3rem]
                  md:leading-[1.1]
                "
              >
                Expedition Gear{" "}
                <span className="text-neutral-500">explained,</span>{" "}
                <span className="bg-gradient-to-r from-[#192c37] to-neutral-500 bg-clip-text text-transparent">
                  positioned & purpose-driven.
                </span>
              </motion.h1>

              <motion.p
                variants={fadeUp}
                className="
                  max-w-md text-md leading-relaxed
                  text-neutral-600
                "
              >
                Every essential item required for a high-altitude expedition is
                clearly demonstrated in a visual layout. Each marker highlights
                a mission-critical component from technical clothing to survival
                systems, shown exactly where and how it is used on the mountain.
              </motion.p>

              <motion.div
                variants={fadeUp}
                className="flex flex-wrap items-center justify-center lg:justify-start gap-3 pt-2"
              >
                <button
                  className="
                    rounded-full
                    border border-neutral-300
                    bg-[#192c37]
                    px-8 py-4
                    text-sm font-medium
                    text-white
                    hover:bg-[#192c37]/40
                    transition
                  "
                >
                  Explore Gear Essentials
                </button>

                {/* <button
                  className="
                    rounded-full
                    border border-neutral-300
                    bg-gray-600/90
                    px-8 py-4
                    text-sm
                    text-white
                    hover:bg-neutral-100
                    transition
                  "
                >
                  Download Checklist
                </button> */}
              </motion.div>
            </div>
          </div>

          {/* ================= DEMO ================= */}
          <div
            className="
              lg:col-span-8
              gear-demo-section
              flex justify-start lg:justify-center
            "
          >
            <ExpeditionGearDiagram />
          </div>
        </div>
      </section>
    </main>
  );
}
